<div class="logout-user">
    <app-header
        [title]="'support.desconectar-usuarios.header.title' | translate"
        [hasBackButton]="false"
        [hasSearchButton]="true"
        [searchInput]="filter"
        [hasMinCharacters]="false"
        [searchPlaceholder]="'support.desconectar-usuarios.header.filter' | translate"
        (onSearch)="onSearch($event)"
    >
        <button customButton styleType="primary" [isLoading]="false" label="support.desconectar-usuarios.header.buttons.logout-all.title" (click)="logoutAll()"></button>
    </app-header>
    <div class="cadastro-cnpj-oficina" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
        <div class="corpo-pagina">
            <div class="card card-default">
                <app-support-gridview [config]="config" [templates]="templatesArray" (onRemove)="logoutUser($event.item.userId)"></app-support-gridview>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
